module.exports = __webpack_public_path__ + "static/media/47.3a3ae026.png";